import React, { useEffect } from "react";
import { sto } from "../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { ButtonBase,  TextField } from "@material-ui/core";
import { QRCodeCanvas } from "qrcode.react";

function TotalsCashairCar(props) {
    const { found, inv, sta,locInv ,onUnmountComplete } = props;

    const styleE = {
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleE1 = {
        BorderBottom: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleHH = {
        border: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.8rem",
        color: "black",
        fontWeight: "bold",
    };
    const styleNum = {
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.9rem",
        color: "black",
        fontWeight: "bold",
    };

    const styleNum1 = {
        BorderBottom: "solid 1px ",
        borderColor: "black",
        textAlign: "center",
        paddingTop: "0.1rem",
        paddingBottom: "0.1rem",
        fontSize: "0.9rem",
        color: "black",
        fontWeight: "bold",
    };
    useEffect(() => {
        setTimeout(async () => {
            onUnmountComplete();
        }, 0);
    }, []);
    return (
        <Grid item container >
            <Grid item container style={{ direction: "rtl", fontFamily: "Amiri-Regular", marginBottom: "0.5rem", marginTop: "0.7rem" }}>
                <Grid item xs={5} container style={styleHH}>
                    <Grid item xs={12}>
                        {"البائع"}
                    </Grid>
                    <Grid item xs={12}>
                        {sto.usernames}
                    </Grid>
                    <Grid item xs={12}>
                        {"العودة في /كيلومتر"}
                    </Grid>
                    <Grid item xs={12}>
                        {sta.tot.CarStructure}
                    </Grid>
                </Grid>
                <Grid item xs={7} container style={styleHH}>
                    <Grid item xs={7} style={styleE1}>
                        {"الاجمالي"}
                    </Grid>
                    <Grid item xs={5} style={styleNum1}>
                        {(sta?.tot?.tot_net - sta?.tot?.amountOfVat + sta?.tot?.discount)?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"الخصم"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {sta?.tot?.discount?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"الضريبة"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {(sta?.tot?.amountOfVat)?.toFixed(2)}
                    </Grid>
                    <Grid item xs={7} style={styleE}>
                        {"الصافي"}
                    </Grid>
                    <Grid item xs={5} style={styleNum}>
                        {sta?.tot?.amountWithVat?.toFixed(2)}
                    </Grid>

                </Grid>

            </Grid>

            <Grid item xs={12} style={{ textAlign: "right", border: "solid 0.1px", }}>
                <TextField fullWidth variant="outlined" size="small"
                    id="refno"
                    inputProps={{ borderColor: "black", color: 'red', fontWeight: "bold", fontSize: "0.9rem", fontFamily: "Amiri-Regular" }}
                    type="text"
                    name="notes"
                    multiline
                    value={found.BillNotes}
                />
            </Grid>

            <Grid item xs={12} style={{ textAlign: "center" }} spacing={0} >
            {(locInv?.Step_inv2 && inv?.ZatcaQR) ?
                    (
                        <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
                            {
                                <QRCodeCanvas value={inv?.ZatcaQR} 
                                size={220}
                                level="M"
                                includeMargin={true}
                                style={{  imageRendering:"pixelated"}}/>
                            }

                        </ButtonBase>
                    ) :
                    (
                        <ButtonBase
                            style={{ borderRadius: "1", margin: 0, padding: 0, alignContent: "center" }}
                        >
                            {
                                <img
                                    src={`data:image/jpeg;base64,${inv.qr_image}`}
                                    style={{ height: "45mm", width: "45mm" }}
                                />
                            }
                        </ButtonBase>
                    )}
            </Grid>
            <Grid
                item
                container
                xs={12}
                style={{
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'break-word',
                    fontWeight: "bold",
                    direction: "rtl",
                    fontFamily: "Amiri-Regular",
                    textAlign: "right"
                }}
            >
                {inv?.notes}
            </Grid>


        </Grid>
    );
}

export default TotalsCashairCar;
